<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png" width="200" />
    <HelloWorld msg="スタジオジャンボ Studio Jambo" />
    <WorksList />
    <MainFooter />
  </div>
</template>

<script>
import HelloWorld from "@/components/HelloWorld.vue";
import WorksList from "@/components/WorksList.vue";
import MainFooter from "@/components/MainFooter.vue";

export default {
  name: "HomeView",
  components: {
    HelloWorld,
    WorksList,
    MainFooter,
  },
};
</script>
